import { Status } from '../../../../models/enums/Status';

export const mapToStatus = (status: boolean) =>
  status ? Status.SUCCESS : Status.ERROR;
